import { cn } from "@/lib/utils";
import { Store } from "lucide-react";

interface Kirana360LogoProps {
  className?: string;
  size?: number;
}

export function Kirana360Logo({ className, size = 20 }: Kirana360LogoProps) {
  return (
    <Store
      className={cn("text-blue-600", className)}
      style={{ width: size, height: size }}
    />
  );
} 